import { FCX } from "@datassential/platform-ui-lib";
import './SmallLoader.scss';
import cn from "classnames";

const SmallLoader: FCX = ({
    className,
}) => {
    return (
        <div
            className={cn("lds-default", className)}
        >
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    );
};

export default SmallLoader;